import { render, staticRenderFns } from "./InventoriesMarketAreasFormCard.vue?vue&type=template&id=ff57111a&"
import script from "./InventoriesMarketAreasFormCard.vue?vue&type=script&lang=ts&"
export * from "./InventoriesMarketAreasFormCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports